<template>
  <component
    :is="id ? 'qx-card' : 'el-dialog'"
    :close-on-click-modal="false"
    title="回单审核"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="1000px"
  >
    <section v-loading="getDetailLoading">
      <qx-detail-box :data="billInfo">
        <span slot="finalFee" slot-scope="prop">
          {{prop.data.finalFee}}元（现金：{{prop.data.finalCash}} + 保费：{{prop.data.insuranceFee}}）
        </span>
      </qx-detail-box>
      <qx-custom-form
        v-show="type === undefined || type === 'approve'"
        @sub="sub"
        :noSubBtn="true"
        ref="baseForm"
        :formData="baseForm"
        labelWidth="120px"
        :handleRefresh="handleRefresh"
      />
    </section>
    <section
      v-show="type === undefined || type === 'approve'"
      :slot="id ? null : 'footer'"
      :class="{
        inWorkspace: Boolean(id),
      }"
    >
      <el-button v-if="!id" @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </component>
</template>

<script>
import {
  orderReceiptDetail,
  orderReceiptApprove,
  orderReceiptQueryBill,
} from 'api/operate';
export default {
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
    handleRefresh: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      // type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      billOriginData: [],
      billList: [],
      normalTitle: [
        {
          prop: 'orderLine',
          label: '线路',
        },
        {
          prop: 'companyName',
          label: '客户',
        },
        {
          prop: 'plateNumber',
          label: '车辆',
        },
        {
          prop: 'source',
          label: '起点',
        },
        {
          prop: 'des',
          label: '终点',
        },
        {
          prop: 'carDependDate',
          label: '出发时间',
        },
        {
          prop: 'carArriveDate',
          label: '到达时间',
        },
        {
          prop: 'finalFee',
          label: '尾款',
          slot: true,
        },
      ],
      billInfo: {
        label: '回单信息',
        tableData: {
          title: [
          ],
          data: {

          },
          approveData: {

          },
        },
      },
      baseForm: {
        form: [
          {
            label: '审核结果',
            value: 'result',
            type: 'radio',
            default: 1,
            onChange: () => {
              this.handleResultChange();
            },
            options: [
              {
                label: '通过',
                value: 1,
              },
              {
                label: '驳回',
                value: 2,
              },
            ],
          },
          {
            label: '驳回内容',
            value: 'rejectContent',
            type: 'checkbox',
            hide: false,
            options: [
              {
                label: '驳回回单',
                value: 'loadState',
              },
              {
                label: '驳回合同',
                value: 'reciveState',
              },
            ],
          },
          {
            label: '审核说明',
            value: 'verifyDesc',
            type: 'input',
            attr: {
              type: 'textarea',
            },
          },
        ],
        rules: {
          result: [ // 审核结果
            { required: true, message: '请选择审核结果', trigger: 'blur' },
          ],
          rejectContent: [ // 驳回内容
            { required: true, message: '请选择驳回内容', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    handleResultChange () {
      const result = this.$refs.baseForm.getVal('result');
      if (result === 1) {
        this.$refs.baseForm.setVal('rejectContent', []);
      }
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: result === 1,
        names: ['rejectContent'],
      });
    },

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(async () => {
        this.$refs.baseForm.reset();
        const res = await orderReceiptDetail({
          orderId: item.orderId,
        });
        this.originData = item;
        res.plateNumber = res.plateNumber + '/' + res.vehicleStatus;
        const billRes = await orderReceiptQueryBill({
          orderId: item.orderId,
        });
        this.billList = [];
        this.billOriginData = billRes.items;
        billRes.items.forEach((item, index) => {
          this.billList.push(
            {
              prop: `billNo${index + 1}`,
              label: `单据编号${index + 1}`,
            },
            {
              prop: `billImg${index + 1}`,
              label: `单据图片${index + 1}`,
              type: 'img',
            },
          );
          res[`billNo${index + 1}`] = item.reciveNumber;
          res[`billImg${index + 1}`] = item.flowUrl;
        });
        this.billInfo.tableData.title = [
          ...this.normalTitle,
          ...this.billList,
        ];
        this.billInfo.tableData.data = res;
        this.handleResultChange();
      });
    },

    customFormPost () {
      this.$refs.baseForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const res = await orderReceiptApprove({
        auditCode: 300008,
        orderId: this.originData.orderId,
        verifyDesc: form.verifyDesc,
        result: form.result,
        receipt: form.rejectContent.indexOf('loadState') !== -1 ? 1 : 0,
        reciveState: form.rejectContent.indexOf('loadState') !== -1 ? 1 : 0,
        load: form.rejectContent.indexOf('reciveState') !== -1 ? 1 : 0,
        loadState: form.rejectContent.indexOf('reciveState') !== -1 ? 1 : 0,
        receiptsStr: JSON.stringify(this.billOriginData),
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
        this.handleRefresh();
      }
    },
  },
  created () {
    if (this.id) {
      this.show({
        orderId: this.id,
      });
    }
  },
};
</script>

<style scoped lang="scss">
.inWorkspace{
  padding-left: 120px;
}
</style>
